import React, { Fragment, useEffect, useState } from "react"
import { Modal } from 'react-bootstrap'

import { formatDate, formatMoney } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

const LABELS = {
	free: 'Бесплатные (тариф 0 или бесплатный период)',
	paid: 'Оплатили текущий месяц',
	credit: 'Не оплатили, работают в кредит',
	unpaid_no_credit: 'Не оплатили, без кредита',
	no_charge: 'Без начисления в этом месяце',
}

// Сводка по активным точкам: группы не пересекаются и в сумме дают все активные.
// Демо-точки (is_internal) сервер не считает.
function ModalPosStatusSummary({ show, onHide }) {
	const [data, setData] = useState(null)
	const [opened, setOpened] = useState(null)

	async function getData() {
		const response = await GET('/admin/pos/status-summary', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		if (show) {
			setOpened(null)
			getData()
		} else {
			setData(null)
		}
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	const total = data?.total ?? 0
	const groups = data?.groups ?? []

	return (
		<Modal show={show} animation={false} centered size="lg"
			onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>Сводка по активным точкам {data?.month ? `за ${data.month}` : ''}</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
				<table className="table table-bordered mb-0">
					<tbody>
						<tr className="fw-bold">
							<td>Активные</td>
							<td className="text-end" style={{ width: 80 }}>{total}</td>
							<td className="text-end" style={{ width: 140 }}></td>
						</tr>
						{groups.map(group => {
							const isOpened = opened === group.key
							return (
								<Fragment key={group.key}>
									<tr style={{ cursor: 'pointer' }}
										className={group.key === 'unpaid_no_credit' && group.total > 0 ? 'text-danger' : ''}
										onClick={() => setOpened(isOpened ? null : group.key)}>
										<td>
											<i className={`uil ${isOpened ? 'uil-angle-down' : 'uil-angle-right'} me-1`}></i>
											{LABELS[group.key]}
										</td>
										<td className="text-end">{group.total}</td>
										<td className="text-end text-nowrap">
											{group.debt > 0 && `долг ${formatMoney(group.debt)}`}
										</td>
									</tr>
									{isOpened && group.poses.map(pos => (
										<tr key={`${group.key}-${pos.id}`} style={{ background: 'var(--dark-surface-2, #f8f9fa)' }}>
											<td colSpan={3}>
												<div className="d-flex gap-2">
													<span className="text-muted">#{pos.id}</span>
													<span className="text-nowrap">{pos.login}</span>
													<span>{pos.name}</span>
													<span className="text-muted text-nowrap ms-auto">
														{pos.debt > 0 && <span className="text-danger me-2">долг {formatMoney(pos.debt)}</span>}
														{pos.monthly_total > 0 && <span className="me-2">в месяц {formatMoney(pos.monthly_total)}</span>}
														{pos.credit_until && <span className="me-2">кредит до {formatDate(pos.credit_until)}</span>}
														{group.key === 'free' && pos.free_until && <span>бесплатно до {formatDate(pos.free_until)}</span>}
													</span>
												</div>
											</td>
										</tr>
									))}
								</Fragment>
							)
						})}
					</tbody>
				</table>
			</Modal.Body>
		</Modal>
	)
}

export default ModalPosStatusSummary
